<template>
  <b-modal title="Itens da Manutenção" v-model="show" size="xl">
    <b-container fluid>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="descricao" v-model="planoTemplate.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- :::::::::::::::::::::::::::: TABELA DE MANUTENÇÕES :::::::::::::::::::::::::::: -->
        <b-col cols="12">
          <b-table
            id="table-plano"
            sticky-header
            style="max-height: 400px"
            bordered
            hover
            small
            head-variant="light"
            :items="planomanutencao.itens"
            :fields="fields.planoManutencaoItens"
          >
            <template #cell(intervalo)="data">
              <div>
                <b-form-textarea v-model="data.item.intervalo" :rows="linhas" />
              </div>
            </template>
            <template #cell(item)="data">
              <div>
                <b-form-textarea v-model="data.item.item" :rows="linhas" />
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-plano-modal ref="templatePlanoManutencao" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="primary" @click="adicionar()"> <b-icon icon="plus-circle" aria-hidden="true" /> </b-button>
      <b-button variant="danger" @click="remover()"> <b-icon icon="dash-circle" aria-hidden="true" /> </b-button>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useTemplateStore } from "@/stores/TemplateStore";
import Notificacao from "@/models/Notificacao";
import TableFields from "@/tools/TableFields";
import Planomanutencao from "@/models_reports/PlanoManutencao";
import PlanomanutencaoTemplateModal from "@/components/modals/template/PlanoManutencaoTemplateModal";

export default {
  name: "ModalDePlanomanutencaoItens",

  components: {
    "template-plano-modal": PlanomanutencaoTemplateModal,
  },

  data() {
    return {
      show: false,
      linhas: 5,
      planomanutencao: new Planomanutencao(),
      planoTemplate: { id: 0, descricao: "", itens: [] },
      fields: new TableFields(),
    };
  },

  methods: {
    templates() {
      this.$refs.templatePlanoManutencao.call();
    },

    adicionar() {
      this.planomanutencao.itens.push({
        item: "- - -",
        intervalo: "- - -",
        historico: [
          { id: 1, data: new Date() },
          { id: 2, data: new Date() },
          { id: 3, data: new Date() },
          { id: 4, data: new Date() },
          { id: 5, data: new Date() },
        ],
      });
    },

    remover() {
      this.planomanutencao.itens.pop();
    },

    salvar() {
      if (this.planoTemplate.id != 0) {
        this.templateStore.ALTERAR_PLANO(this.planoTemplate).then(() => {
          for (var i = 0; i < this.planoTemplate.itens.length; i++) {
            this.templateStore.ALTERAR_PLANO_ITEM(this.planoTemplate.itens[i]);
          }
          this.store.NOTIFICAR(new Notificacao("Checklist salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        //pode ser implementado no futuro!
      }
    },

    loadTemplate(template) {
      this.planoTemplate = template;
      this.planomanutencao.itens = template.itens;
      this.planomanutencao.setHistorico();
    },

    call(planomanutencao) {
      this.planomanutencao = planomanutencao;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();

    return {
      store,
      templateStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
